export enum Icons {
    Pin = 'icon-pin',
    Polygon = 'icon-area'
}